<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-actions>
  <button mat-button (click)="onSubmit()">Da</button>
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>Ne</button>
</mat-dialog-actions>
